"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const axios_1 = __importDefault(require("axios"));
const react_i18next_1 = require("react-i18next");
const api_1 = require("@/api");
const functions_1 = require("@/common/functions");
const errors_1 = require("@/common/errors");
const _1 = require(".");
function default_1({ roomId, recordFileChoice, recordField, expenseRecordFormSetValue, }) {
    const [isUploadingFile, setIsUploadingFile] = (0, react_1.useState)(false);
    const { t } = (0, react_i18next_1.useTranslation)();
    const uploadPresignedFile = ({ presignedData, uploadFile, }) => __awaiter(this, void 0, void 0, function* () {
        const { presigned_url, content_type, file_url } = presignedData;
        yield axios_1.default
            .put(presigned_url, uploadFile, { headers: { 'Content-Type': content_type } })
            .then(() => __awaiter(this, void 0, void 0, function* () {
            yield (0, api_1.patchData)(`/api/v1/room/${roomId}/settlement-manage/expense/upload-complete`, {
                field_type: recordFileChoice,
                filename: uploadFile.name,
                file_url: file_url,
            })
                .then(res => {
                expenseRecordFormSetValue(`${recordField}_filename`, res.data.result.filename);
                (0, functions_1.showToastMessage)({ message: t('저장 완료') });
            })
                .catch(err => {
                const { status } = err.response;
                if (status === 403)
                    (0, errors_1.handle403Error)(err);
                else
                    alert((0, errors_1.commonErrorMsg)(status) + '(failed to complete upload)');
                setIsUploadingFile(false);
            });
        }))
            .catch(err => {
            alert((0, errors_1.commonErrorMsg)(err.response.status) + '(failed uploading images to AWS)');
            setIsUploadingFile(false);
        });
    });
    const supportExtensionRegExp = new RegExp(/(jpeg|jpg|png|webp|heic|heif|zip|pdf)/);
    const compressableImageType = new RegExp(/image\/(jpeg|jpg|png|webp)/);
    const uploadRecordFile = (files) => __awaiter(this, void 0, void 0, function* () {
        setIsUploadingFile(true);
        let uploadFile = files[0];
        const fileType = uploadFile.type;
        let fileExtension = fileType.split('/').pop() || '';
        if (!supportExtensionRegExp.test(fileExtension)) {
            (0, functions_1.showToastMessage)({ message: t('이미지, pdf, zip 파일만 올릴 수 있어요') });
            setIsUploadingFile(false);
        }
        else if (uploadFile.name.length > 218) {
            (0, functions_1.showToastMessage)({ message: t('파일 이름을 짧게 줄여주세요') });
            setIsUploadingFile(false);
        }
        else {
            if (compressableImageType.test(fileType)) {
                try {
                    uploadFile = yield new Promise((resolve, reject) => {
                        (0, functions_1.compressImageFile)({
                            imageFile: uploadFile,
                            maxWidth: 1500,
                            quality: 0.7,
                            onCompressSuccess: (compressedFile, convertedExtension) => {
                                fileExtension = convertedExtension;
                                resolve(compressedFile);
                            },
                            onCompressError: reject,
                            isCheckingSizeElsewhere: true,
                        });
                    });
                }
                catch (_a) {
                    setIsUploadingFile(false);
                    return;
                }
            }
            if (uploadFile.size > 3000000) {
                (0, functions_1.showToastMessage)({ message: t('최대 3MB 업로드 할 수 있어요') });
                setIsUploadingFile(false);
            }
            else {
                yield (0, api_1.putData)(`/api/v1/room/${roomId}/settlement-manage/expense/upload`, {
                    field_type: recordFileChoice,
                    file_extension: fileExtension,
                })
                    .then(res => {
                    const presignedData = res.data.result;
                    uploadPresignedFile({ presignedData, uploadFile });
                })
                    .catch(err => {
                    var _a, _b, _c;
                    const { status } = err.response;
                    if (status === 403)
                        (0, errors_1.handle403Error)(err);
                    else if (status === 400) {
                        const alertType = (_c = (_b = (_a = err.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.meta) === null || _c === void 0 ? void 0 : _c.alert_type;
                        alert((0, errors_1.commonErrorMsg)(alertType) + '(failed to presign upload)');
                    }
                    else
                        alert((0, errors_1.commonErrorMsg)(status) + '(failed to presign upload)');
                    setIsUploadingFile(false);
                });
            }
        }
    });
    return ((0, jsx_runtime_1.jsx)(_1.RecordFileUploadButton, { recordField: recordField, uploadRecordFile: uploadRecordFile, isUploadingFile: isUploadingFile }));
}
exports.default = default_1;
